"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TrophySVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var TrophySVG = function TrophySVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M22.54 17.9c8.7-2.11 7.38-11 7.37-11.06a1 1 0 00-1-.84H24V5a2 2 0 00-2-2H10a2 2 0 00-2 2v1H3.08a1 1 0 00-1 .84c0 .09-1.33 9 7.37 11.06 1.33 2.39 3.4 4.47 5.57 5a.61.61 0 00-.02.1v5h-5a1 1 0 000 2h12a1 1 0 000-2h-5v-5a.61.61 0 000-.13c2.14-.5 4.22-2.59 5.54-4.97zM24 13V8h4a7.49 7.49 0 01-4.41 7.45A8.42 8.42 0 0024 13zM4 8h4v5a8.55 8.55 0 00.41 2.45A7.47 7.47 0 014 8zm15.33 3.13L18 12.53l.25 1.94c.06.46-.22.66-.63.45L16 14.07l-1.66.85c-.41.21-.69 0-.63-.45l.29-1.94-1.29-1.4c-.31-.34-.19-.68.26-.76l1.77-.37.88-1.73c.21-.4.55-.4.76 0l.88 1.73 1.81.34c.45.11.57.45.26.79z"
  }));
};
exports.TrophySVG = TrophySVG;
TrophySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TrophySVG);
exports.default = _default;